import { render, staticRenderFns } from "./order-middle.vue?vue&type=template&id=1799db49&scoped=true"
import script from "./order-middle.vue?vue&type=script&lang=ts"
export * from "./order-middle.vue?vue&type=script&lang=ts"
import style0 from "./order-middle.vue?vue&type=style&index=0&id=1799db49&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1799db49",
  null
  
)

export default component.exports